import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Spinner,
	styled,
	Text,
} from '@volkswagen-onehub/components-core';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { Vehicle, VehicleStatus } from '@esportal/portal-service';
import { useTrackingManager } from '../../../tracking/useTrackingManager';
import { formatOwnership } from '../../../tracking/trackingHelper';

const PersonVehiclesCTAsContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;

	& div > div > div:first-child {
		flex: 1;
	}

	& div > div > div:last-child {
		flex: 1;
	}
`;

const CTAStyledConfirm = styled(CTA)`
	background-color: #00b0f0;
`;

export const PersonVehiclesCTAs = ({
	vehicle,
	isConfirming,
	handleConfirm,
	openDelete,
}: {
	vehicle: Vehicle;
	isConfirming: string | null;
	handleConfirm: (vehicle: Vehicle) => void;
	openDelete: (vehicle: Vehicle) => void;
}): React.ReactElement => {
	const trackingManager = useTrackingManager();

	const handleDeleteOnClick = () => {
		openDelete(vehicle);
		trackingManager.trackClubVWButtonClick(
			'Eliminar',
			{ contentId: `Delete vehicle - ${vehicle.comercialDenomination}` },
			{ vehicle: formatOwnership([vehicle]) },
		);
	};

	const handleConfirmOnClick = () => {
		handleConfirm(vehicle);
		trackingManager.trackClubVWButtonClick(
			'Confirmar',
			{ contentId: `Confirm vehicle - ${vehicle.comercialDenomination}` },
			{ vehicle: formatOwnership([vehicle]) },
		);
	};

	return (
		<PersonVehiclesCTAsContainer>
			<Container
				wrap={'never'}
				horizontalAlign={'space-between'}
				gutter={ContainerGutter.static150}
				padding={{
					top: ContainerPadding.static400,
					bottom: {
						[Breakpoints.default]: ContainerPadding.dynamic0200,
						[Breakpoints.b1280]: ContainerPadding.static0,
					},
				}}
				shrinkContent
			>
				<CTA tag="button" emphasis="secondary" onClick={handleDeleteOnClick} aria-label="clickDelete">
					<Text>Eliminar</Text>
				</CTA>
				<Container stretchContent>
					{vehicle.status == VehicleStatus.READY ? (
						<CTA tag="button" emphasis="secondary" disabled={true} aria-label="confirmedCar">
							<Checkmark variant="small" aria-hidden /> Confirmado
						</CTA>
					) : isConfirming == vehicle.frame ? (
						<CTAStyledConfirm tag="button" emphasis="primary" disabled={true} aria-label="clickConfirm">
							<Spinner />
						</CTAStyledConfirm>
					) : (
						<CTA
							tag="button"
							emphasis="primary"
							disabled={false}
							onClick={handleConfirmOnClick}
							aria-label="clickConfirm"
						>
							<Text bold>Confirmar</Text>
						</CTA>
					)}
				</Container>
			</Container>
		</PersonVehiclesCTAsContainer>
	);
};
